"use client";

import { X } from "lucide-react";
import { useDrawerStore } from "@/stores/drawerStore";

export default function HeaderNavToggle() {
  const { primaryOpen, setPrimaryOpen, secondaryOpen, setSecondaryOpen } =
    useDrawerStore();

  const isOpen = primaryOpen || secondaryOpen;

  const toggle = () => {
    // فقط primary رو کنترل کنیم، یا اینکه هر دو رو ببندیم؟ فعلاً مثل قبلی:
    setPrimaryOpen(!primaryOpen);
    if (secondaryOpen) setSecondaryOpen(false);
  };

  return (
    <button
      onClick={toggle}
      className="lg:hidden"
      aria-label={isOpen ? "Close menu" : "Open menu"}
    >
      {isOpen ? (
        <X className="w-5 h-5 stroke-1" />
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M12 17H19M5 12H19M5 7H19" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" /> </svg>
      )}
    </button>
  );
}
